import {createSelector} from 'reselect';
import {getCombinedData} from '../../utils/statsUtils';

// Getters for full data sets
const getGoals = (state) => state.dsaConfig && state.dsaConfig.goals || [];
export const getGoalAnswers = (state) => state.dsa && state.dsa.dsaGoals || [];
const getExtensions = (state) => state.dsaConfig && state.dsaConfig.extensions || [];
const getExtensionAnswers = (state) => state.dsa && state.dsa.dsaExtensions || [];

// Getters for area data sets
const getAreaId = (state, props) => props && props.area && props.area.id;

export const makeGetAreaGoalsProgress = () => {
  return createSelector(
    [getAreaId, getGoals, getGoalAnswers],
    (areaId, goals, answers) => {
      let progress = {
        current: 0,
        total: 0
      };

      let combinedGoals = getCombinedData(goals, answers, 'goal');
      let subareaGoals = combinedGoals.filter(g => g.area === areaId);
      let answeredSubareaGoals = subareaGoals.filter(g => Number.isInteger(g.answer));

      progress.total += subareaGoals.length;
      progress.current += answeredSubareaGoals.length;

      return progress;
    }
  );
};

export const makeGetAreaActiveExtensions = () => {
  return createSelector(
    [getAreaId, getExtensions, getExtensionAnswers],
    (areaId, extensions, dsaExtensions) => {
      let combinedExtensions = getCombinedData(extensions, dsaExtensions, 'extension');
      let activeIds = combinedExtensions.filter(e => e.active && e.area === areaId).map(e => e.id);
      return extensions.filter(e => activeIds.indexOf(e.id) >= 0);
    }
  );
};



// WEBPACK FOOTER //
// ./src/selectors/dsa/goalsSelectors.js